<template>
  <div style="margin-top:20px;">
    <h3 class="mx-auto" style="margin-top:10px;">参加申請が完了しました</h3>
    <div class="left" style="margin-top:20px;">
      <div>
        <span style="font-size:130%;"></span>
      </div>
      <div class="shadow-lg p-3 mb-5 bg-white rounded font-weight-bolder">受付番号：<span style="font-size:210%;">{{orderNumber}}</span>
      </div>
      <div class="alert alert-light" role="alert">
        <p>※受付番号は、参加状況の照会に必要となります。
        以下の方法などで大切に保管をお願いいたします。</p>
        <p>・メモをとる</p>
        <p>・スクリーンショットをとる</p>
      </div>
      <div class="form-group row" style="margin-top:50px;">
        <div class="col-sm-12">
          <button class="btn btn-primary btn-block" v-on:click="ontop">トップへ</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Complete",
  computed: {
    // 受付番号
    orderNumber() {
      return this.$store.state.orderNumber;
    },
  },
  mounted() {
      this.$store.commit("setIsShowNextBtn", false);
      this.$store.commit("setIsApplied", true);
},
  methods: {
    ontop: function() {
      this.$router.push("/top");
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
